import { WEBAPP_URL, AUTHORITY, CLIENT_ID, SCOPE } from "gatsby-env-variables"

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: WEBAPP_URL,
    postLogoutRedirectUri: WEBAPP_URL,
  },
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ["openid", SCOPE],
}

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
}
